import { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import type {
  BookitupDocumentType,
  Language,
} from "../../types/BookitupDocument";

const PACKING_DOCUMENT_TYPES: BookitupDocumentType[] = [
  "DELIVERYNOTE",
  "PACKING_LIST",
];

const VatNote = ({
  language,
  documentType,
}: {
  language?: Language;
  documentType?: BookitupDocumentType;
}) => {
  const { profile } = useContext(ResourceContext);
  const { smallScaleBusiness, vatStatement, englishVatStatement } =
    profile ?? {};
  const statement = language === "english" ? englishVatStatement : vatStatement;

  if (
    smallScaleBusiness &&
    statement &&
    (!documentType || !PACKING_DOCUMENT_TYPES.includes(documentType))
  ) {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: statement }}
        style={{ marginBottom: 20 }}
      />
    );
  }
  return null;
};

export default VatNote;
